import useSiteSettings from "../lib/useSiteSettings";
import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { usePhoneLayout } from "../lib/PhoneLayout";
import { EMBLEM_VIEWBOX, EMBLEM_GROUPS } from "../lib/brandEmblemPaths";
import useDialogFocus from "../lib/useDialogFocus";
const KEY = "shsons-emblem-trace-v3";
export default function BrandReveal() {
  const reduced = useReducedMotion();
  const settings=useSiteSettings();
  const phone = usePhoneLayout();
  const [show, setShow] = useState(() => { try { return !sessionStorage.getItem(KEY); } catch { return true; } });
  const active = show && !reduced && !phone && settings.opening_animation_enabled!==false;
  const dialogRef = useDialogFocus(active, () => setShow(false));
  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem(KEY, "1"); } catch {}
    if (reduced || phone) { setShow(false); return; }
    const timeout = setTimeout(() => setShow(false), 2400);
    return () => clearTimeout(timeout);
  }, [show, reduced, phone]);
  useEffect(() => {
    const replay = () => {
      if (phone) {
        if (!reduced) document.querySelectorAll('[data-phone-brand-mark]').forEach(mark =>
          mark.animate([{opacity:.65,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],
            {duration:400,easing:'cubic-bezier(.22,1,.36,1)'}));
      } else setShow(true);
    };
    window.addEventListener("shsons:replay-logo", replay);
    return () => window.removeEventListener("shsons:replay-logo", replay);
  }, [phone, reduced]);
  return <AnimatePresence>{active && <motion.div ref={dialogRef} tabIndex={-1} role="dialog" aria-modal="true" data-testid="brand-reveal" aria-label="S H & SONS opening animation" initial={{opacity:1}} exit={{y:"-100%",transition:{duration:.75,ease:[.76,0,.24,1]}}} className="fixed inset-0 z-[200] bg-white flex flex-col items-center justify-center select-none">
    {settings.opening_logo_image?<motion.img src={settings.opening_logo_image} alt="S H & SONS" className="w-[48vw] max-w-[260px] max-h-[45vh] object-contain" initial={{opacity:0,y:12}} animate={{opacity:1,y:0}} transition={{duration:.7}}/>:<svg viewBox={EMBLEM_VIEWBOX} className="w-[48vw] max-w-[260px] max-h-[45vh]" role="img" aria-label="S H & SONS official tree emblem">
      {EMBLEM_GROUPS.map((g,i)=><g key={i} transform={g.transform}>{g.paths.map((d,j)=><g key={j}>
        <motion.path d={d} fill="none" stroke={g.fill} strokeWidth="150" strokeLinecap="round" strokeLinejoin="round" initial={{pathLength:0,opacity:1}} animate={{pathLength:1,opacity:0}} transition={{pathLength:{duration:phone?.65:1.35,delay:i*.045,ease:"easeInOut"},opacity:{duration:.4,delay:phone?.75:1.5}}}/>
        <motion.path d={d} fill={g.fill} initial={{opacity:0}} animate={{opacity:1}} transition={{duration:phone?.4:.65,delay:(phone?.45:1)+i*.035,ease:"easeOut"}}/>
      </g>)}</g>)}
    </svg>}
    <motion.p className="eyebrow mt-6" initial={{opacity:0,y:6}} animate={{opacity:1,y:0}} transition={{delay:phone?.55:1.25,duration:.45}}>{settings.opening_caption??"Crafting since 1986"}</motion.p>
    <button type="button" onClick={()=>setShow(false)} className="text-xs text-mocha mt-4 min-h-11 px-4 underline underline-offset-4" aria-label="Skip opening animation">Enter showroom</button>
  </motion.div>}</AnimatePresence>;
}
